import React from 'react';
import _ from 'lodash';

import { useLookUpReturnAuthorizationLazyQuery } from 'generated/graphql';
import * as types from './types';



export type IFetchMode = 'salesOrder' | 'returnAuthorization';

export interface IRecord {
  type: 'salesOrder' | 'returnAuthorization';
  id: string;
  identifier: string;
}

export function useLookUpReturnAuthorization(fetchMode?: IFetchMode) {
  const [fnQuery, tuple] = useLookUpReturnAuthorizationLazyQuery({});

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState): Promise<IRecord[]> => {
      const result = await fnQuery({
        variables: {
          searchText: _.trim(formState.value)
        }
      });

      const returnAuthorizations = result.data?.returnAuthorizations.nodes ?? [];
      const allRecords = _.map(returnAuthorizations, (auth): IRecord[] => [
        {
          type: 'salesOrder',
          id: auth.order.id,
          identifier: auth.order.orderNumber
        },
        {
          type: 'returnAuthorization',
          id: auth.id,
          identifier: auth.returnNumber
        }
      ]);

      const flattened = _.flatten(allRecords);
      if (fetchMode === 'salesOrder') {
        return _.filter(flattened, f => f.type === 'salesOrder');
      } else if (fetchMode === 'returnAuthorization') {
        return _.filter(flattened, f => f.type === 'returnAuthorization');
      }

      return _.uniqBy(flattened, f => f.identifier);
    },
    [
      fnQuery,
      fetchMode
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
